import { useQuery } from "react-query";
import { getTypeList } from "../../../../actions/Utilities/BusinessLicensesPermitsType";

export default function useGetTypeList() {
  return useQuery("GetType", getTypeList, {
    refetchOnWindowFocus: false,
  });
}
